module.exports = __webpack_public_path__ + "img/Pattern02.969918eb.png";